import type { ID } from '@octopus-do/octopus-project-core'
import { put, select } from 'redux-saga/effects'

import { CommentReadsActions } from '../actions'
import { selectOpenTargets } from '../selectors'

// Whatever is open right now has been seen. Runs after the actions that open a
// pin or a modal and after the ones that bring new comments in, so a reply
// landing in an open thread is marked the moment it shows
export function* markOpenTargets() {
  const targets: ID[] = yield select(selectOpenTargets)

  for (const target of targets) {
    yield put(CommentReadsActions.markRead({ target }))
  }
}
